import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { useCurrentLocale } from '@locales/client';
import { fetcherWithToken } from '@/shared/api/fetcher';


const useBanners = ({ enabled }) => {
  const lang = useCurrentLocale();
  const { data, error, isLoading } = useSWR(
    enabled ? `/banners?lang=${lang}` : null,
    fetcherWithToken
  );

  return {
    data,
    error,
    isLoading,
  };
};

const useVerificationBonuses = () => {
  const { data, error, trigger, isLoading } = useSWRMutation(
    '/verificationBonuses',
    fetcherWithToken
  );

  return {
    data,
    error,
    trigger,
    isLoading,
  };
};

const useSaveFields = () => {
  const { trigger } = useSWRMutation(
    '/payment/fiat/saveFields',
    (url, { arg }) =>
      fetcherWithToken(url, {
        method: 'POST',
        body: JSON.stringify(arg),
      })
  );

  return {
    trigger,
  };
};

export { useBanners, useVerificationBonuses, useSaveFields };
